import React from 'react';
import "../css/ContextMenu.css";

class ContextMenu extends React.Component {

    menuRef = React.createRef();
    previouslyFocused = null;

    // LEAK-2: keep a stable reference to the handler so it can be removed on
    // unmount. The old code added an anonymous listener in componentDidMount
    // with no componentWillUnmount, so every menu open permanently leaked a
    // listener that kept firing (and calling onClose on an unmounted component).
    handleOutsideMouseDown = (e) => {
        if (!e.target.closest('.contextmenu')) {
            this.props.onClose();
        }
    };

    // Every item in this menu is a one-shot action, but only an *outside* click
    // used to dismiss it — so after choosing "Download" the menu stayed open,
    // hovering over the page until clicked away. Close on any activation inside.
    handleMenuClick = (e) => {
        if (e.target.closest('button, [role="menuitem"], a')) {
            this.props.onClose();
        }
    };

    handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.stopPropagation();
            this.props.onClose();
            return;
        }
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

        // Roving arrow-key navigation between the menu's items.
        const items = this.itemNodes();
        if (items.length === 0) return;
        e.preventDefault();
        const current = items.indexOf(document.activeElement);
        const delta = e.key === 'ArrowDown' ? 1 : -1;
        const next = current === -1
            ? (delta === 1 ? 0 : items.length - 1)
            : (current + delta + items.length) % items.length;
        items[next].focus();
    };

    itemNodes = () => {
        if (!this.menuRef.current) return [];
        return Array.from(this.menuRef.current.querySelectorAll('button, [role="menuitem"], a[href]'));
    };

    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideMouseDown);
        document.addEventListener('keydown', this.handleKeyDown);
        // A context menu opened from the keyboard is useless if focus stays on
        // the card behind it, so move focus to the first item and put it back
        // where it came from on close.
        this.previouslyFocused = document.activeElement;
        this.itemNodes()[0]?.focus();
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideMouseDown);
        document.removeEventListener('keydown', this.handleKeyDown);
        if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
            this.previouslyFocused.focus();
        }
    }

    render() {
        return (
            <div
                ref={this.menuRef}
                className="contextmenu"
                style={{ left: this.props.position.x, top: this.props.position.y }}
                role="menu"
                aria-label={this.props['aria-label'] || 'File actions'}
                onClick={this.handleMenuClick}
            >
                {this.props.children}
            </div>
        );
    }
}

export default ContextMenu;
